export default __webpack_public_path__ + "static/media/o-c.ffb32cad.png";